import React from 'react';
import { Link } from 'react-router-dom';
import './Industries.css';

const ElecIco = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
);
const HomeIco = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
);
const FashionIco = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.38 3.46L16 2a8.5 8.5 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"></path></svg>
);
const HealthIco = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
);
const ToysIco = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
);
const PetIco = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a3 3 0 0 0-3 3v1H6a3 3 0 0 0-3 3v1a3 3 0 0 0 3 3h2v2H6a3 3 0 0 0-3 3v1a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-1a3 3 0 0 0-3-3h-2v-2h2a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-3V5a3 3 0 0 0-3-3z"></path></svg>
);

const industries = [
  { icon: <ElecIco />,     label: "Electronics",     img: "/homepageimages/industries-electronics-homaepage-image.jpg", path: "/electronics-fulfilment-uk" },
  { icon: <HomeIco />,     label: "Home & Kitchen", img: "/homepageimages/industries-home&kitchen-homepage-image.jpg", path: "/food-drink-fulfilment-uk" },
  { icon: <FashionIco />,  label: "Fashion",         img: "/homepageimages/industries-fashion-homepages-image.jpg", path: "/fashion-apparel-fulfilment-uk" },
  { icon: <HealthIco />,   label: "Health & Beauty", img: "/homepageimages/industries-health&beauty-homepage-image.jpg", path: "/beauty-cosmetics-fulfilment-uk" },
  { icon: <ToysIco />,     label: "Toys & Lifestyle",img: "/homepageimages/industries-toys-homepage-image.jpg" },
  { icon: <PetIco />,      label: "Pet Products",    img: "/homepageimages/industries-petfood-homepage-image.jpg" },
];

const Industries: React.FC = () => {
  return (
    <section className="is-section">
      <div className="is-container">
        {/* TOP SECTION: Text + Image */}
        <div className="is-top">
          <div className="is-top-left">
            <div className="is-eyebrow">
              <span className="is-dash"></span> INDUSTRIES
            </div>
            <h2 className="is-title">
              Industries We Serve Across<br />
              <span className="text-blue">UK E-Commerce &amp; Amazon</span>
            </h2>
            <p className="is-desc">
              Trusted eCommerce fulfilment UK and Amazon FBA fulfilment services for sellers across multiple product categories, delivering reliable pick and pack services, inventory management, and scalable warehouse solutions.
            </p>
          </div>
          
          <div className="is-top-right">
            <div className="is-hero">
              <div className="is-blob-o" />
              <div className="is-blob-w">
                <img src="/homepageimages/industries-hero.jpg" alt="E-Commerce Fulfilment UK Packaging" style={{ width: '100%', height: '100%', objectFit: 'cover' }} loading="lazy" />
              </div>
              <div className="is-info">
                <div className="is-ic">
                  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 8l9-5 9 5v9l-9 5-9-5z" /><path d="M3 8l9 5 9-5M12 13v9" />
                  </svg>
                </div>
                <div>
                  <h4>Multiple Product Categories</h4>
                  <p>From electronics to everyday essentials, we support eCommerce brands of all sizes.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM SECTION: 6 Cards */}
        <div className="is-bottom-slider">
          <div className="is-slider-track">
            <div className="is-slider-group">
              {industries.map((ind, i) => (
                <Link to={ind.path || '#'} key={i} className="is-card">
                  <div className="is-card-img" style={{ backgroundImage: `url('${ind.img}')` }}></div>
                  <div className="is-card-info">
                    <div className="is-card-icon-box">
                      {ind.icon}
                    </div>
                    <div className="is-card-text-row">
                      <span className="is-card-title">{ind.label}</span>
                      <span className="is-card-arrow">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1A44E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            {/* Duplicated group for infinite scrolling marquee */}
            <div className="is-slider-group" aria-hidden="true">
              {industries.map((ind, i) => (
                <Link to={ind.path || '#'} key={'dup-'+i} className="is-card" tabIndex={-1}>
                  <div className="is-card-img" style={{ backgroundImage: `url('${ind.img}')` }}></div>
                  <div className="is-card-info">
                    <div className="is-card-icon-box">
                      {ind.icon}
                    </div>
                    <div className="is-card-text-row">
                      <span className="is-card-title">{ind.label}</span>
                      <span className="is-card-arrow">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1A44E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;

